import React from 'react';
import type { CategorizeNoticeState } from './types';

interface Props {
  notice: CategorizeNoticeState;
  onUndo: () => void;
}

export default function CategorizeInlineNotice({ notice, onUndo }: Props): React.ReactElement {
  const detail =
    notice.action === 'approve'
      ? 'Restore from Cleanup history within 30 days.'
      : "Vela won't suggest a category for this one again this cycle.";

  return (
    <div className="mt-4 py-2.5 px-3.5 bg-white border-l-[3px] border-teal-dark flex justify-between items-center text-small text-ink2 max-w-[720px]">
      <div>
        <strong className="font-bold text-ink">{notice.message}</strong> {detail}
      </div>
      <button
        type="button"
        onClick={onUndo}
        className="bg-transparent border-none text-teal-dark text-small font-bold cursor-pointer underline p-0"
      >
        Undo
      </button>
    </div>
  );
}